import { Axios } from 'axios'
import { RootState } from '@/store'
import { Kamoku } from '@/repositories/fuzoku-meisai/data'
import {
  ResponseYukashoukenSetting,
  ResponseYukashoukenSettingItem
} from '@/repositories/fuzoku-meisai/kaikei-kijun/data'

export interface YukashoukenRepository {
  list (): Promise<ResponseYukashoukenSetting>;

  save (saiken: ResponseYukashoukenSettingItem[], other: ResponseYukashoukenSettingItem[]): Promise<void>;
}

type PostParamItem = {
  itemName: string;
  amount:number;
  setting: Kamoku[];
}

type PostParam = {
  saiken: PostParamItem[];
  other: PostParamItem[];
}

export class YukashoukenRepositoryImpl implements YukashoukenRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/yukashouken`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  async list (): Promise<ResponseYukashoukenSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (saiken: ResponseYukashoukenSettingItem[], other: ResponseYukashoukenSettingItem[]): Promise<void> {
    const postParams: PostParam = {
      saiken: saiken.map(p => ({
        itemName: p.itemName,
        amount: p.amount,
        setting: p.setting.targets
      })),
      other: other.map(p => ({
        itemName: p.itemName,
        amount: p.amount,
        setting: p.setting.targets
      }))
    }
    await this.http.post(this.baseUrl, postParams)
  }
}
